import { render, staticRenderFns } from "./modal-confirmar-escoger.vue?vue&type=template&id=4071da2c&scoped=true"
import script from "./modal-confirmar-escoger.vue?vue&type=script&lang=js"
export * from "./modal-confirmar-escoger.vue?vue&type=script&lang=js"
import style0 from "./modal-confirmar-escoger.vue?vue&type=style&index=0&id=4071da2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071da2c",
  null
  
)

export default component.exports